const PatientSvg = () => {
  return (
    <svg
      width="12"
      height="15"
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.666992 14.6667C0.666992 13.2523 1.2289 11.8957 2.22909 10.8955C3.22928 9.89532 4.58584 9.33342 6.00033 9.33342C7.41481 9.33342 8.77137 9.89532 9.77156 10.8955C10.7718 11.8957 11.3337 13.2523 11.3337 14.6667H10.0003C10.0003 13.6059 9.5789 12.5885 8.82875 11.8383C8.07861 11.0882 7.06119 10.6667 6.00033 10.6667C4.93946 10.6667 3.92204 11.0882 3.1719 11.8383C2.42175 12.5885 2.00033 13.6059 2.00033 14.6667H0.666992ZM6.00033 8.66675C3.79033 8.66675 2.00033 6.87675 2.00033 4.66675C2.00033 2.45675 3.79033 0.666748 6.00033 0.666748C8.21033 0.666748 10.0003 2.45675 10.0003 4.66675C10.0003 6.87675 8.21033 8.66675 6.00033 8.66675ZM6.00033 7.33342C7.47366 7.33342 8.66699 6.14008 8.66699 4.66675C8.66699 3.19341 7.47366 2.00008 6.00033 2.00008C4.52699 2.00008 3.33366 3.19341 3.33366 4.66675C3.33366 6.14008 4.52699 7.33342 6.00033 7.33342Z"
        fill="#00995D"
      />
    </svg>
  )
}

export default PatientSvg
